"use client";

import { Suspense } from "react";
import Link from "next/link";
import type { ButtonProps } from "app/_components/components/Button";
import { Button } from "app/_components/components/Button";
import { BaseLink } from "./BaseLink";

export function RegistrationLink({
  referralCode,
  label,
  ...props
}: {
  referralCode?: string;
  label: string;
} & ButtonProps) {
  return (
    <Suspense
      fallback={
        <Button asChild id="register-exchange" variant="theme" {...props}>
          <Link href="https://exchange.gemini.com/register">{label}</Link>
        </Button>
      }
    >
      <BaseLink
        href="https://exchange.gemini.com/register"
        id="register-exchange"
        label={label}
        referralCode={referralCode}
        {...props}
      />
    </Suspense>
  );
}
